import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { CreateProductionTriggerInput } from "~/gql/graphqlBase.generated";

interface ProductionTriggersState {
	createTriggerInput?: CreateProductionTriggerInput;
	triggerFormOpen: boolean;
}

const initialState: ProductionTriggersState = {
	triggerFormOpen: false
};

export const productionTriggerSlice = createSlice({
	initialState,
	name: "productionTrigger",
	reducers: {
		closeTriggerForm: (state) => {
			state.triggerFormOpen = false;
		},
		openTriggerForm: (state) => {
			state.triggerFormOpen = true;
		},
		setCreateTriggerInput: (state, action: PayloadAction<CreateProductionTriggerInput | null>) => {
			if (action.payload === null) {
				state.createTriggerInput = undefined;
				return;
			}
			state.createTriggerInput = { ...action.payload };
		},
		updateCreateTriggerInput: (state, action: PayloadAction<Partial<CreateProductionTriggerInput>>) => {
			if (!action.payload) {
				state.createTriggerInput = undefined;
			} else {
				if (!state.createTriggerInput) return;
				state.createTriggerInput = { ...state.createTriggerInput, ...action.payload };
			}
		}
	}
});

export const { closeTriggerForm, openTriggerForm, setCreateTriggerInput, updateCreateTriggerInput } =
	productionTriggerSlice.actions;

export default productionTriggerSlice.reducer;
